// 首页数据收集
import http from "@/promise/http"
const CONTROLLER_NAME = "/dataSummary/";

// 首页数据
export const getHomePageData = projectId => {
  return http.post(CONTROLLER_NAME.concat('homePageData'), projectId)
}

// 统计近30天的考勤数据 
export function getRecentAttendance(projectId, yearMonth) {
  return http.post(CONTROLLER_NAME.concat('recentAttendance'), { projectId, yearMonth })
}